import React, { useEffect,useState } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import mainlogo from "../assets/mainlogo.png";
import { siteSettings } from "../Data/axios";

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [siteData, setSiteData] = useState({}); // Initialize as an empty object
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
            let isMounted = true;
            const fetchData = async () => {
                try {
                    const data = await siteSettings.getSettingsForWebsite();
                    setSiteData(data || {});
                    
                } catch (err) {
                        setError(err.message || "Failed to fetch site data");
                } finally {
                        setLoading(false);
                }
            };
    
            fetchData();
            return () => {
                isMounted = false;
            };
        }, {});

    return (
        <>
        <div className="font-ubuntu">
            {/* Top Header */}
            <div className="bg-gray-50 text-black py-2 text-xs md:text-sm">
                <div className="container mx-auto flex justify-between items-center">
                    {/* Left Side */}
                    <div className="flex items-center space-x-4">
                        <div className="flex items-center space-x-1">
                            <i className="fas fa-phone-alt"></i>
                            <span>{siteData.helpline}</span>
                        </div>
                        <div className="items-center space-x-1 hidden md:flex">
                            <i className="fas fa-envelope"></i>
                            <span>{siteData.site_email }</span>
                        </div>
                    </div>
                    {/* Right Side */}
                    <div className="flex text-sm md:text-lg items-center space-x-4">
                    <a href={siteData.site_twitter} className="text-blue-500">
                        <i className="fab fa-twitter hover:text-yellow-500"></i>
                    </a>
                    <a href={siteData.site_instagram} className="text-pink-500">
                        <i className="fab fa-instagram hover:text-yellow-500"></i>
                    </a>
                    <a href={siteData.site_linkedin} className="text-blue-700">
                        <i className="fab fa-linkedin hover:text-yellow-500"></i>
                    </a>
                    <a href={siteData.site_facebook} className="text-blue-600">
                        <i className="fab fa-facebook hover:text-yellow-500"></i>
                    </a>
                    </div>
                </div>
            </div>

            {/* Main Header */}
            <div className="bg-white shadow-md py-4 relative">
                <div className="container mx-auto flex justify-between items-center">
                    {/* Logo */}
                    {/* <div className="flex items-center"> */}
                        <img
                            src={mainlogo}
                            alt="Logo"
                            className="h-auto w-60"
                        />
                    {/* </div> */}

                    {/* Hamburger Button */}
                    <button
                        className="text-black md:hidden z-40 mr-2"
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                    >
                        <i className={`fas ${isMenuOpen ? "fa-times" : "fa-bars"} text-2xl`}></i>
                    </button>

                    {/* Navigation */}
                    <nav
                        className={`${isMenuOpen ? "block" : "hidden"} 
                            absolute top-16 left-0 w-full p-5 z-30 bg-black bg-opacity-90 md:bg-transparent md:static md:flex md:items-center md:justify-center md:space-x-6 md:p-0`}
                    >
                        <a href="/home" className="block py-2 text-white md:text-black hover:text-yellow-500">
                            Home
                        </a>
                        <a href="/about" className="block py-2 text-white md:text-black hover:text-yellow-500">
                            About
                        </a>
                        <a href="/features" className="block py-2 text-white md:text-black hover:text-yellow-500">
                            Features
                        </a>
                        <a href="/blogs" className="block py-2 text-white md:text-black hover:text-yellow-500">
                            Blogs
                        </a>
                        <a href="/plans" className="block py-2 text-white md:text-black hover:text-yellow-500">
                            Plans
                        </a>
                        <a href="/contact-us" className="block py-2 text-white md:text-black hover:text-yellow-500">
                            Contact
                        </a>
                        
                    </nav>

                        <a
                            href="/login"
                            className="py-2 px-6 bg-csyellow text-white font-medium rounded-lg hover:bg-yellow-500 transition-colors duration-300 hidden md:inline-block"
                        >
                            Login
                        </a>
                </div>
            </div>
            </div>
        </>
    );
};

export default Header;
